import { getTokens } from '@src/utils/auth/auth-client';
import { MiscLambdaFetch } from '@src/utils/fetch-utils';

// Newton is hosted per-tenant; the host is the same across all environments.
export const NEWTON_HOST = 'tinuiti.newtonresearch.ai';

// A freshly issued, single-use ID token — what both the embed and Newton's API expect.
// forceRefresh:true on every call is parity with the old fetchAuthSession({forceRefresh: true}).
// Whether Newton really needs a fresh token per call is an open question for the Newton team
// (ADR-006); until it's answered, don't trade Newton breaking for lower /auth/refresh load.
export const getNewtonToken = async (): Promise<string> => {
  const { idToken } = await getTokens({ forceRefresh: true });
  return idToken;
};

// POST /newton/project_mapping (bpm-lambdas `misc` service). Sets newton_project_slug for the
// client; internal-only, enforced server-side. The value then rides the company-info payload.
export const saveNewtonProjectMapping = async (
  company: string,
  newtonProjectSlug: string
): Promise<void> => {
  await MiscLambdaFetch('/newton/project_mapping', {
    method: 'POST',
    body: { company, newtonProjectSlug }
  });
};
